export default "__VITE_ASSET__DAgw0c1o__"